var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5336 23.9739L25.9283 27.3686C24.5688 28.3627 22.9133 28.7711 21.3069 28.5947L22.5336 23.9739Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0618 19.3349L23.4393 20.562L24.6665 15.9395C25.3959 16.2633 26.0796 16.7246 26.6782 17.3232C27.2768 17.9218 27.738 18.6055 28.0618 19.3349Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9732 22.5348L28.5938 21.3082C28.7701 22.9145 28.3616 24.5699 27.3676 25.9292L23.9732 22.5348Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6931 15.4076L21.4665 20.0281L18.0721 16.6337C19.4315 15.6397 21.0869 15.2313 22.6931 15.4076Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4066 22.6944L20.0274 21.4677L16.6327 18.0731C15.6386 19.4325 15.2303 21.0881 15.4066 22.6944Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3222 26.6792C16.7237 26.0807 16.2625 25.397 15.9387 24.6677L20.5606 23.4408L19.3336 28.0626C18.6043 27.7389 17.9207 27.2777 17.3222 26.6792Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.27318 27.4278C2.67475 25.8294 2.66784 23.2447 4.25774 21.6548L21.6538 4.25872C23.2437 2.66882 25.8284 2.67573 27.4268 4.27415L29.5975 6.44481C29.9971 6.84441 29.9864 7.48633 29.6863 7.96184C28.5682 9.73385 28.7868 12.1114 30.3384 13.663C31.8899 15.2145 34.2675 15.4331 36.0395 14.315C36.515 14.0149 37.1569 14.0043 37.5565 14.4039L39.7272 16.5745C41.3256 18.1729 41.3325 20.7576 39.7426 22.3475L22.3465 39.7436C20.7566 41.3335 18.172 41.3266 16.5735 39.7282L14.4029 37.5575C14.0033 37.1579 14.014 36.516 14.314 36.0405C15.4322 34.2685 15.2135 31.8909 13.662 30.3394C12.1104 28.7878 9.73287 28.5692 7.96087 29.6873C7.48535 29.9874 6.84343 29.998 6.44383 29.5984L4.27318 27.4278ZM28.1504 28.1513C31.5289 24.7728 31.5142 19.2804 28.1176 15.8838C24.7209 12.4871 19.2285 12.4724 15.85 15.851C12.4715 19.2295 12.4861 24.7219 15.8828 28.1185C19.2795 31.5152 24.7718 31.5299 28.1504 28.1513Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.276537f60d88259785bec199beffed0e.svg";
export { ForwardRef as ReactComponent };